import React from 'react';
import { ApolloClient, ApolloLink, ApolloProvider, InMemoryCache } from '@apollo/client';
import { BrowserRouter, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthWrapper } from 'bench-internal-theme';
import TaskManager from './TaskManager';
import { createGlobalStyle } from 'styled-components';
import { TaskManagerContextProvider } from './TaskManagerContext';
import { serverlessGraphqlServiceHttpLink } from 'bk-web-app';
import { GlobalRoleCode } from 'bench-internal-theme/AuthWrapper';
import { TaskManagerFeatureFlagProvider } from './TaskManagerFeatureFlagProvider';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';
import { parse, stringify } from 'query-string';
import 'react-toastify/dist/ReactToastify.css';

export const graphqlClient = new ApolloClient({
  link: ApolloLink.from([serverlessGraphqlServiceHttpLink]),
  cache: new InMemoryCache(),
});

const GlobalStyle = createGlobalStyle`
  body, body.md-default-theme, html {
    background-color: rgb(228, 230, 233);
  } 
  body {
    overflow: scroll;
    padding: 12px;
  }
`;

const App = () => (
  <ApolloProvider client={graphqlClient}>
    <GlobalStyle />
    <AuthWrapper
      useLoggedInPersonQuery
      authorizedGlobalRoles={[GlobalRoleCode.SPECIALIST, GlobalRoleCode.SUPERUSER]}
    >
      <BrowserRouter>
        <QueryParamProvider
          adapter={ReactRouter5Adapter}
          options={{
            objectToSearchString: stringify,
            searchStringToObject: parse,
            removeDefaultsFromUrl: false,
          }}
        >
          <TaskManagerContextProvider>
            <TaskManagerFeatureFlagProvider>
              <Route path="*" exact={false}>
                <TaskManager requireTeam />
              </Route>
            </TaskManagerFeatureFlagProvider>
          </TaskManagerContextProvider>
          <ToastContainer
            theme="light"
            position="bottom-right"
            hideProgressBar
            toastStyle={{ backgroundColor: '#fff' }}
          />
        </QueryParamProvider>
      </BrowserRouter>
    </AuthWrapper>
  </ApolloProvider>
);
export default App;
